import { Navigate } from "react-router-dom";
import { Permissions } from "features/RolesAndPermissions/constants/permission.constants";
import ActivityLogPage from "features/ActivityLog";

import DashboardEcommerce from "features/Dashboard";
import Login from "features/Authentication/Login";
import ForgotPassword from "features/Authentication/ForgotPassword";
import ResetPassword from "features/Authentication/ResetPassword";
import Logout from "features/Authentication/Logout";
import EnquiryList from "features/Enquiries/EnquiryList";
import QuotationList from "features/Quotations/QuotationList";
import EnquirySiteVisitList from "features/EnquirySiteVisits/EnquirySiteVisitList";
import ClientAdvanceList from "features/ClientAdvances/ClientAdvanceList";
import WorkOrderList from "features/WorkOrders/WorkOrderList";
import ContractList from "features/Amc/AmcList";
import Basic404 from "components/errors/Basic404";
import EnquirySiteVisitForm from "features/EnquirySiteVisits/EnquirySiteVisitForm";
import ClientList from "features/Clients/ClientList";
import ClientForm from "features/Clients/ClientForm";
import ComplaintMaterialList from "features/ComplaintMaterials/ComplaintMaterialList";
import ComplaintMaterialForm from "features/ComplaintMaterials/ComplaintMaterialForm";
import ComplaintMaterialOverview from "features/ComplaintMaterials/ComplaintMaterialOverview";
import ClientOverview from "features/Clients/ClientOverview";
import EnquiryOverview from "features/Enquiries/EnquiryOverview";
import PettyWorkForm from "features/PettyWorks/PettyWorkForm";
import EnquiryForm from "features/Enquiries/EnquiryForm";
import QuotationForm from "features/Quotations/QuotationForm";
import QuotationOverview from "features/Quotations/QuotationOverview";
import EnquirySiteVisitOverview from "features/EnquirySiteVisits/EnquirySiteVisitOverview";
import WorkOrderOverview from "features/WorkOrders/WorkOrderOverview";
import WorkOrderForm from "features/WorkOrders/WorkOrderForm";
import ClientAdvanceForm from "features/ClientAdvances/ClientAdvanceForm";
import EmployeeAdvanceForm from "features/EmployeeAdvances/EmployeeAdvanceForm";
import EmployeeAdvanceList from "features/EmployeeAdvances/EmployeeAdvanceList";
import EmployeeAdvanceOverview from "features/EmployeeAdvances/EmployeeAdvanceOverview";
import PettyWorkOverview from "features/PettyWorks/PettyWorkOverview";
import UserList from "features/Users/UserList";
import UserForm from "features/Users/UserForm";
import UserOverview from "features/Users/UserOverview";
import ClientAdvanceOverview from "features/ClientAdvances/ClientAdvanceOverview";
import MaterialRequestList from "features/MaterialRequests/MaterialRequestList";
import MaterialRequestForm from "features/MaterialRequests/MaterialRequestForm";
import { MaterialRequestFormSource } from "features/MaterialRequests/constants/material-request.constants";
import ContractForm from "features/Amc/AmcForm";
import VisitLogList from "features/AmcVisitLogs/VisitLogList";
import VisitLogForm from "features/AmcVisitLogs/VisitLogForm";
import AmcVisitOverview from "features/AmcVisitLogs/AmcVisitOverview";
import MaterialRequestOverview from "features/MaterialRequests/MaterialRequestOverview";
import PurchaseOrderList from "features/PurchaseOrders/PurchaseOrderList";
import PurchaseOrderOverview from "features/PurchaseOrders/PurchaseOrderOverview";
import PurchaseOrderForm from "features/PurchaseOrders/PurchaseOrderForm";
import SupplierList from "features/Suppliers/SupplierList";
import SupplierForm from "features/Suppliers/SupplierForm";
import SupplierOverview from "features/Suppliers/SupplierOverview";
import ViewContractDetails from "features/Amc/AmcOverview";
import RoleList from "features/RolesAndPermissions/RoleList";
import SetPermissionForm from "features/RolesAndPermissions/RolePermissionForm";
import RequirePermission from "./RequirePermission";
import Basic403 from "components/errors/Basic403";
import InvoiceList from "features/Invoices/InvoiceList";
import InvoiceOverview from "features/Invoices/InvoiceOverview";
import InvoiceForm from "features/Invoices/InvoiceForm";
import PaymentList from "features/Payments/PaymentList";
import PaymentOverview from "features/Payments/PaymentOverview";
import ClientAdvanceSettlementList from "features/ClientAdvanceSettlements/ClientAdvanceSettlementList";
import EmployeeAdvanceSettlementList from "features/EmployeeAdvanceSettlements/EmployeeAdvanceSettlementList";
import PaymentForm from "features/Payments/PaymentForm";
import WorkAssignmentList from "features/WorkAssignments/WorkAssignmentList";
import AttendanceReportPage from "features/EmployeeAttendance/AttendanceReportPage";
import WorkOrderReportPage from "features/WorkOrders/WorkOrderReportPage";
import MaterialList from "features/Materials/MaterialList";
import MaterialForm from "features/Materials/MaterialForm";
import ToolList from "features/Tools/ToolList";
import ToolForm from "features/Tools/ToolForm";
import MaterialInOutList from "features/MaterialInOuts/MaterialInOutList";
import MaterialInOutForm from "features/MaterialInOuts/MaterialInOutForm";
import ToolInOutList from "features/ToolInOuts/ToolInOutList";
import ToolInOutForm from "features/ToolInOuts/ToolInOutForm";
import EmployeeAttendance from "features/EmployeeAttendance";
import LeaveApplicationList from "features/Leaves/LeaveApplicationList";
import LeaveApplicationForm from "features/Leaves/LeaveApplicationForm";
import LeaveApplicationOverview from "features/Leaves/LeaveApplicationOverview";
import HolidayList from "features/Holidays/HolidayList";
import EmployeeList from "features/Employees";
import EmployeeForm from "features/Employees/EmployeeForm";
import EmployeeOverview from "features/Employees/EmployeeOverview";
import UserPayroll from "features/Payroll";
import PayrollRunDetail from "features/Payroll/PayrollRunOverview";
import PayslipList from "features/Payroll/PayslipList";
import MyPayslips from "features/Payroll/MyPayslips";
import PettyWorkList from "features/PettyWorks/PettyWorkList";
import Settings from "features/Settings";
import DepartmentList from "features/Departments/DepartmentList";
import DesignationList from "features/Designations/DesignationList";
import PaymentExpectationList from "features/PaymentExpectations/PaymentExpectationList";
import PaymentExpectationForm from "features/PaymentExpectations/PaymentExpectationForm";
import PaymentExpectationOverview from "features/PaymentExpectations/PaymentExpectationOverview";

const authProtectedRoutes = [
  {
    path: "/dashboard",
    component: (
      <RequirePermission permission={Permissions.DASHBOARD.READ}>
        <DashboardEcommerce />
      </RequirePermission>
    ),
  },
  { path: "/index", component: <DashboardEcommerce /> },

  //User Routes
  {
    path: "/user-management/users",
    component: (
      <RequirePermission permission={Permissions.USER.READ}>
        <UserList />
      </RequirePermission>
    ),
  },
  {
    path: "/user-management/users/create",
    component: (
      <RequirePermission permission={Permissions.USER.CREATE}>
        <UserForm />
      </RequirePermission>
    ),
  },
  {
    path: "/user-management/users/edit/:id",
    component: (
      <RequirePermission permission={Permissions.USER.UPDATE}>
        <UserForm isEdit={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/user-management/users/:id",
    component: (
      <RequirePermission permission={[Permissions.USER.READ]}>
        <UserOverview />
      </RequirePermission>
    ),
  },
  // Role Routes
  {
    path: "/user-management/roles-and-permissions",
    component: (
      <RequirePermission permission={Permissions.ROLES_AND_PERMISSIONS.READ}>
        <RoleList />
      </RequirePermission>
    ),
  },
  {
    path: "/user-management/roles-and-permissions/:id/set-permissions",
    component: (
      <RequirePermission permission={Permissions.ROLES_AND_PERMISSIONS.UPDATE}>
        <SetPermissionForm />
      </RequirePermission>
    ),
  },

  {
    path: "/schedule",
    component: (
      <RequirePermission permission={Permissions.WORK_ASSIGNMENT.READ}>
        <WorkAssignmentList />
      </RequirePermission>
    ),
  },
  {
    path: "/reports/work-assignments",
    component: <Navigate to="/schedule" replace />,
  },
  {
    path: "/reports/attendance",
    component: (
      <RequirePermission
        permission={[
          Permissions.EMPLOYEE_ATTENDANCE.READ,
          Permissions.EMPLOYEE_ATTENDANCE.VIEW_REPORT,
        ]}
      >
        <AttendanceReportPage />
      </RequirePermission>
    ),
  },
  {
    path: "/reports/work-orders",
    component: (
      <RequirePermission
        permission={[
          Permissions.WORK_ORDER.READ,
          Permissions.WORK_ORDER.VIEW_REPORT,
        ]}
      >
        <WorkOrderReportPage />
      </RequirePermission>
    ),
  },
  {
    path: "/user-management/assignments",
    component: <Navigate to="/schedule" replace />,
  },

  // Enquiry Routes
  {
    path: "/enquiry-management",
    component: (
      <RequirePermission permission={Permissions.ENQUIRY.READ}>
        <EnquiryList />
      </RequirePermission>
    ),
  },
  {
    path: "/enquiry-management/enquiries/create",
    component: (
      <RequirePermission permission={Permissions.ENQUIRY.CREATE}>
        <EnquiryForm />
      </RequirePermission>
    ),
  },
  {
    path: "/enquiry-management/enquiries/edit/:id",
    component: (
      <RequirePermission permission={Permissions.ENQUIRY.UPDATE}>
        <EnquiryForm isEdit={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/enquiry-management/enquiries/:id",
    component: <EnquiryOverview />,
  },

  // Petty Work Routes
  {
    path: "/petty-works",
    component: (
      <RequirePermission permission={Permissions.PETTY_WORK.READ}>
        <PettyWorkList />
      </RequirePermission>
    ),
  },
  {
    path: "/petty-works/create",
    component: (
      <RequirePermission permission={Permissions.PETTY_WORK.CREATE}>
        <PettyWorkForm />
      </RequirePermission>
    ),
  },
  {
    path: "/petty-works/edit/:id",
    component: (
      <RequirePermission permission={Permissions.PETTY_WORK.UPDATE}>
        <PettyWorkForm isEdit={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/petty-works/:id",
    component: (
      <RequirePermission permission={Permissions.PETTY_WORK.READ}>
        <PettyWorkOverview />
      </RequirePermission>
    ),
  },

  // Work Order Routes
  {
    path: "/work-orders",
    component: (
      <RequirePermission permission={Permissions.WORK_ORDER.READ}>
        <WorkOrderList />
      </RequirePermission>
    ),
  },
  {
    path: "/work-orders/create",
    component: (
      <RequirePermission permission={Permissions.WORK_ORDER.CREATE}>
        <WorkOrderForm />
      </RequirePermission>
    ),
  },
  {
    path: "/work-orders/edit/:id",
    component: (
      <RequirePermission permission={Permissions.WORK_ORDER.UPDATE}>
        <WorkOrderForm isEdit={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/work-orders/:id",
    component: (
      <RequirePermission permission={Permissions.WORK_ORDER.READ}>
        <WorkOrderOverview />
      </RequirePermission>
    ),
  },

  // Site Visit Routes
  {
    path: "/enquiry-management/site-visits",
    component: (
      <RequirePermission permission={Permissions.SITE_VISIT.READ}>
        <EnquirySiteVisitList />
      </RequirePermission>
    ),
  },

  {
    path: "/enquiry-management/site-visits/create",
    component: (
      <RequirePermission permission={Permissions.SITE_VISIT.CREATE}>
        <EnquirySiteVisitForm />
      </RequirePermission>
    ),
  },
  {
    path: "/enquiry-management/enquiries/:enquiryId/site-visits/create",
    component: (
      <RequirePermission permission={Permissions.SITE_VISIT.CREATE}>
        <EnquirySiteVisitForm />
      </RequirePermission>
    ),
  },
  {
    path: "/enquiry-management/site-visits/my-schedule",
    component: <Navigate to="/enquiry-management/site-visits" replace />,
  },
  {
    path: "/enquiry-management/site-visits/:id",
    component: (
      <RequirePermission permission={Permissions.SITE_VISIT.READ}>
        <EnquirySiteVisitOverview />
      </RequirePermission>
    ),
  },
  {
    path: "/enquiry-management/site-visits/edit/:id",
    component: (
      <RequirePermission permission={Permissions.SITE_VISIT.UPDATE}>
        <EnquirySiteVisitForm isEditMode={true} />
      </RequirePermission>
    ),
  },

  // Quotation Routes
  {
    path: "/quotations",
    component: (
      <RequirePermission permission={Permissions.QUOTATION.READ}>
        <QuotationList />
      </RequirePermission>
    ),
  },
  {
    path: "/quotations/create",
    component: (
      <RequirePermission permission={Permissions.QUOTATION.CREATE}>
        <QuotationForm />
      </RequirePermission>
    ),
  },
  {
    path: "/quotations/edit/:id",
    component: (
      <RequirePermission permission={Permissions.QUOTATION.UPDATE}>
        <QuotationForm isEdit={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/quotations/:id",
    component: (
      <RequirePermission permission={Permissions.QUOTATION.READ}>
        <QuotationOverview />
      </RequirePermission>
    ),
  },

  // Client Routes
  {
    path: "/clients",
    component: (
      <RequirePermission permission={Permissions.CLIENT.READ}>
        <ClientList />
      </RequirePermission>
    ),
  },
  {
    path: "/clients/create",
    component: (
      <RequirePermission permission={Permissions.CLIENT.CREATE}>
        <ClientForm />
      </RequirePermission>
    ),
  },
  {
    path: "/clients/edit/:id",
    component: (
      <RequirePermission permission={Permissions.CLIENT.UPDATE}>
        <ClientForm isEdit={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/clients/:id",
    component: (
      <RequirePermission permission={Permissions.CLIENT.READ}>
        <ClientOverview />
      </RequirePermission>
    ),
  },

  // Complaint Materials
  {
    path: "/complaint-materials",
    component: (
      <RequirePermission permission={Permissions.COMPLAINT_MATERIAL.READ}>
        <ComplaintMaterialList />
      </RequirePermission>
    ),
  },
  {
    path: "/complaint-materials/create",
    component: (
      <RequirePermission permission={Permissions.COMPLAINT_MATERIAL.CREATE}>
        <ComplaintMaterialForm />
      </RequirePermission>
    ),
  },
  {
    path: "/complaint-materials/edit/:id",
    component: (
      <RequirePermission permission={Permissions.COMPLAINT_MATERIAL.UPDATE}>
        <ComplaintMaterialForm />
      </RequirePermission>
    ),
  },
  {
    path: "/complaint-materials/:id",
    component: (
      <RequirePermission permission={Permissions.COMPLAINT_MATERIAL.READ}>
        <ComplaintMaterialOverview />
      </RequirePermission>
    ),
  },

  {
    path: "/inventory-management/materials",
    component: (
      <RequirePermission permission={Permissions.MATERIAL.READ}>
        <MaterialList />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/materials/edit/:id",
    component: (
      <RequirePermission permission={Permissions.MATERIAL.UPDATE}>
        <MaterialForm />
      </RequirePermission>
    ),
  },

  {
    path: "/inventory-management/tools",
    component: (
      <RequirePermission permission={Permissions.TOOL.READ}>
        <ToolList />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/tools/edit/:id",
    component: (
      <RequirePermission permission={Permissions.TOOL.UPDATE}>
        <ToolForm />
      </RequirePermission>
    ),
  },

  {
    path: "/inventory-management/material-in-outs",
    component: (
      <RequirePermission permission={Permissions.MATERIAL_IN_OUT.READ}>
        <MaterialInOutList />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/material-in-outs/edit/:id",
    component: (
      <RequirePermission permission={Permissions.MATERIAL_IN_OUT.UPDATE}>
        <MaterialInOutForm />
      </RequirePermission>
    ),
  },

  {
    path: "/inventory-management/tool-in-outs",
    component: (
      <RequirePermission permission={Permissions.TOOL_IN_OUT.READ}>
        <ToolInOutList />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/tool-in-outs/edit/:id",
    component: (
      <RequirePermission permission={Permissions.TOOL_IN_OUT.UPDATE}>
        <ToolInOutForm />
      </RequirePermission>
    ),
  },

  // Suppliers
  {
    path: "/inventory-management/suppliers",
    component: (
      <RequirePermission permission={Permissions.SUPPLIER.READ}>
        <SupplierList />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/suppliers/create",
    component: (
      <RequirePermission permission={Permissions.SUPPLIER.CREATE}>
        <SupplierForm />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/suppliers/edit/:id",
    component: (
      <RequirePermission permission={Permissions.SUPPLIER.UPDATE}>
        <SupplierForm isEdit={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/suppliers/:id",
    component: (
      <RequirePermission permission={Permissions.SUPPLIER.READ}>
        <SupplierOverview />
      </RequirePermission>
    ),
  },

  // Purchase Order Routes
  {
    path: "/inventory-management/purchase-orders",
    component: (
      <RequirePermission permission={Permissions.PURCHASE_ORDER.READ}>
        <PurchaseOrderList />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/purchase-orders/create",
    component: (
      <RequirePermission permission={Permissions.PURCHASE_ORDER.CREATE}>
        <PurchaseOrderForm />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/purchase-orders/edit/:id",
    component: (
      <RequirePermission permission={Permissions.PURCHASE_ORDER.UPDATE}>
        <PurchaseOrderForm isEdit={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/purchase-orders/:id",
    component: (
      <RequirePermission permission={Permissions.PURCHASE_ORDER.READ}>
        <PurchaseOrderOverview />
      </RequirePermission>
    ),
  },

  // Material Request Routes
  {
    path: "/inventory-management/material-requests",
    component: (
      <RequirePermission permission={Permissions.MATERIAL_REQUEST.READ}>
        <MaterialRequestList />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/material-requests/new/from-work-order/:jobId",
    component: (
      <RequirePermission permission={Permissions.MATERIAL_REQUEST.CREATE}>
        <MaterialRequestForm
          sourceType={MaterialRequestFormSource.WORK_ORDER}
        />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/material-requests/new/from-petty-work/:jobId",
    component: (
      <RequirePermission permission={Permissions.MATERIAL_REQUEST.CREATE}>
        <MaterialRequestForm
          sourceType={MaterialRequestFormSource.PETTY_WORK}
        />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/material-requests/:id/edit",
    component: (
      <RequirePermission permission={Permissions.MATERIAL_REQUEST.UPDATE}>
        <MaterialRequestForm mode="edit" />
      </RequirePermission>
    ),
  },
  {
    path: "/inventory-management/material-requests/:id",
    component: (
      <RequirePermission permission={Permissions.MATERIAL_REQUEST.READ}>
        <MaterialRequestOverview />
      </RequirePermission>
    ),
  },

  // HR Management - Employee Attendance
  {
    path: "/hr-management/attendance-sheet",
    component: (
      <RequirePermission permission={Permissions.EMPLOYEE_ATTENDANCE.READ}>
        <EmployeeAttendance />
      </RequirePermission>
    ),
  },

  {
    path: "/hr-management/leave-applications",
    component: (
      <RequirePermission permission={Permissions.LEAVE_APPLICATION.READ}>
        <LeaveApplicationList />
      </RequirePermission>
    ),
  },
  {
    path: "/hr-management/leave-applications/new",
    component: (
      <RequirePermission permission={Permissions.LEAVE_APPLICATION.CREATE}>
        <LeaveApplicationForm />
      </RequirePermission>
    ),
  },
  {
    path: "/hr-management/leave-applications/:id",
    component: (
      <RequirePermission permission={Permissions.LEAVE_APPLICATION.READ}>
        <LeaveApplicationOverview />
      </RequirePermission>
    ),
  },

  {
    path: "/hr-management/holidays",
    component: (
      <RequirePermission permission={Permissions.HOLIDAY.READ}>
        <HolidayList />
      </RequirePermission>
    ),
  },

  // HR Management - Employees
  {
    path: "/employees",
    component: (
      <RequirePermission permission={Permissions.EMPLOYEE.READ}>
        <EmployeeList />
      </RequirePermission>
    ),
  },
  {
    path: "/employees/create",
    component: (
      <RequirePermission permission={Permissions.EMPLOYEE.CREATE}>
        <EmployeeForm />
      </RequirePermission>
    ),
  },
  {
    path: "/employees/edit/:id",
    component: (
      <RequirePermission permission={Permissions.EMPLOYEE.UPDATE}>
        <EmployeeForm isEdit={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/employees/:id",
    component: (
      <RequirePermission
        permission={[
          Permissions.EMPLOYEE.READ,
          Permissions.EMPLOYEE.READ_BASIC,
        ]}
      >
        <EmployeeOverview />
      </RequirePermission>
    ),
  },

  // Redirect old attendance path to HR Management
  {
    path: "/user-management/attendance-sheet",
    component: <Navigate to="/hr-management/attendance-sheet" replace />,
  },

  // Payroll (under Finance)
  {
    path: "/finance/payroll",
    component: (
      <RequirePermission permission={Permissions.PAYROLL.READ}>
        <UserPayroll />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/payroll/:id",
    component: (
      <RequirePermission permission={Permissions.PAYROLL.READ}>
        <PayrollRunDetail />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/payslips",
    component: (
      <RequirePermission permission={Permissions.PAYROLL.READ}>
        <PayslipList />
      </RequirePermission>
    ),
  },
  {
    path: "/my/payslips",
    component: <MyPayslips />,
  },
  {
    path: "/user-management/payroll",
    component: <Navigate to="/finance/payroll" replace />,
  },

  // Client Advance Routes
  {
    path: "/finance/client-advances",
    component: (
      <RequirePermission permission={Permissions.CLIENT_ADVANCE.READ}>
        <ClientAdvanceList />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/client-advances/create",
    component: (
      <RequirePermission permission={Permissions.CLIENT_ADVANCE.CREATE}>
        <ClientAdvanceForm />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/client-advances/edit/:id",
    component: (
      <RequirePermission permission={Permissions.CLIENT_ADVANCE.UPDATE}>
        <ClientAdvanceForm isEdit={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/client-advances/:id",
    component: (
      <RequirePermission permission={Permissions.CLIENT_ADVANCE.READ}>
        <ClientAdvanceOverview />
      </RequirePermission>
    ),
  },

  // Client Advance Settlement Routes
  {
    path: "/finance/client-advance-settlements",
    component: (
      <RequirePermission permission={Permissions.CLIENT_ADVANCE_SETTLEMENT.READ}>
        <ClientAdvanceSettlementList />
      </RequirePermission>
    ),
  },

  // Employee Advance Routes
  {
    path: "/finance/employee-advances",
    component: (
      <RequirePermission permission={Permissions.EMPLOYEE_ADVANCE.READ}>
        <EmployeeAdvanceList />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/employee-advances/create",
    component: (
      <RequirePermission permission={Permissions.EMPLOYEE_ADVANCE.CREATE}>
        <EmployeeAdvanceForm />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/employee-advances/edit/:id",
    component: (
      <RequirePermission permission={Permissions.EMPLOYEE_ADVANCE.UPDATE}>
        <EmployeeAdvanceForm isEdit={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/employee-advances/:id",
    component: (
      <RequirePermission permission={Permissions.EMPLOYEE_ADVANCE.READ}>
        <EmployeeAdvanceOverview />
      </RequirePermission>
    ),
  },

  // Employee Advance Settlement Routes
  {
    path: "/finance/employee-advance-settlements",
    component: (
      <RequirePermission permission={Permissions.EMPLOYEE_ADVANCE_SETTLEMENT.READ}>
        <EmployeeAdvanceSettlementList />
      </RequirePermission>
    ),
  },

  // Invoices Routes
  {
    path: "/finance/invoices",
    component: (
      <RequirePermission permission={Permissions.INVOICE.READ}>
        <InvoiceList />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/invoices/edit/:id",
    component: (
      <RequirePermission permission={Permissions.INVOICE.UPDATE}>
        <InvoiceForm />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/invoices/:id",
    component: (
      <RequirePermission permission={Permissions.INVOICE.READ}>
        <InvoiceOverview />
      </RequirePermission>
    ),
  },

  // Payment Routes
  {
    path: "/finance/payments/create",
    component: (
      <RequirePermission permission={Permissions.PAYMENT.CREATE}>
        <PaymentForm />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/payments",
    component: (
      <RequirePermission permission={Permissions.PAYMENT.READ}>
        <PaymentList />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/payments/:id",
    component: (
      <RequirePermission permission={Permissions.PAYMENT.READ}>
        <PaymentOverview />
      </RequirePermission>
    ),
  },

  // Payment Expectation Routes
  {
    path: "/finance/payment-expectations",
    component: (
      <RequirePermission permission={Permissions.PAYMENT_EXPECTATION.READ}>
        <PaymentExpectationList />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/payment-expectations/create",
    component: (
      <RequirePermission permission={Permissions.PAYMENT_EXPECTATION.CREATE}>
        <PaymentExpectationForm />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/payment-expectations/edit/:id",
    component: (
      <RequirePermission permission={Permissions.PAYMENT_EXPECTATION.UPDATE}>
        <PaymentExpectationForm isEdit={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/finance/payment-expectations/:id",
    component: (
      <RequirePermission permission={Permissions.PAYMENT_EXPECTATION.READ}>
        <PaymentExpectationOverview />
      </RequirePermission>
    ),
  },

  // AMC Routes
  {
    path: "/amc-management",
    component: (
      <RequirePermission permission={Permissions.AMC.READ}>
        <ContractList />
      </RequirePermission>
    ),
  },
  {
    path: "/amc-management/:id",
    component: (
      <RequirePermission permission={Permissions.AMC.READ}>
        <ViewContractDetails />
      </RequirePermission>
    ),
  },
  {
    path: "/amc-management/create",
    component: (
      <RequirePermission permission={Permissions.AMC.CREATE}>
        <ContractForm />
      </RequirePermission>
    ),
  },

  {
    path: "/amc-management/edit/:id",
    component: (
      <RequirePermission permission={Permissions.AMC.UPDATE}>
        <ContractForm isEdit={true} />
      </RequirePermission>
    ),
  },
  // AMC Visit Logs Routes
  {
    path: "/amc-management/visit-logs/edit/:visitId",
    component: (
      <RequirePermission permission={Permissions.AMC_VISIT.UPDATE}>
        <VisitLogForm isEdit={true} />
      </RequirePermission>
    ),
  },

  {
    path: "/amc-management/visit-logs/:visitId",
    component: (
      <RequirePermission permission={Permissions.AMC_VISIT.READ}>
        <AmcVisitOverview />
      </RequirePermission>
    ),
  },
  {
    path: "/amc-management/visit-logs",
    component: (
      <RequirePermission permission={Permissions.AMC_VISIT.READ}>
        <VisitLogList />
      </RequirePermission>
    ),
  },

  // HR Management - Departments
  {
    path: "/hr-management/departments",
    component: (
      <RequirePermission permission={Permissions.DEPARTMENT.READ}>
        <DepartmentList />
      </RequirePermission>
    ),
  },

  // HR Management - Designations
  {
    path: "/hr-management/designations",
    component: (
      <RequirePermission permission={Permissions.DESIGNATION.READ}>
        <DesignationList />
      </RequirePermission>
    ),
  },

  // Settings Routes
  {
    path: "/settings",
    component: (
      <RequirePermission permission={Permissions.SETTINGS.READ}>
        <Settings />
      </RequirePermission>
    ),
  },

  {
    path: "/activity-log",
    component: (
      <RequirePermission permission={Permissions.ACTIVITY_LOG.READ}>
        <ActivityLogPage />
      </RequirePermission>
    ),
  },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/not-found" replace /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/reset-password/:token", component: <ResetPassword /> },
  { path: "/not-found", component: <Basic404 /> },
  { path: "/unauthorized", component: <Basic403 /> },
];

export { authProtectedRoutes, publicRoutes };
